// frontend/src/components/Navbar.jsx
import "../styles/Navbar.scss";
import { useNavigate, Link } from "react-router-dom";
import { useContext, useEffect, useRef, useState } from "react";
import { ProfileContext } from "../context/ProfileContext";
import { toast } from "react-toastify";
import api from "../api/axios";
import { getAvatarUrl } from "../utils/getAssetUrl";
import { useTheme } from "../context/ThemeContext";
import NotificationBell from "./NotificationBell";

export default function Navbar({ onHamburgerClick }) {
  const navigate = useNavigate();
  const { profile, setProfile } = useContext(ProfileContext);
  const { theme, setTheme } = useTheme();

  const roleLower = (profile?.role || profile?.userRole || localStorage.getItem("role") || "").toString().toLowerCase();
  const displayName = profile?.fullName || localStorage.getItem("fullName") || "Kullanıcı";
  const displayRole = (profile?.role || profile?.userRole || localStorage.getItem("role") || "—")?.toString().toUpperCase();

  // Her zaman profil resmi alanı olsun (müşteri dahil)
  const rawAvatar = profile?.profileImage ?? localStorage.getItem("profileImage");
  const imgSrc = getAvatarUrl(rawAvatar) || "/noavatar.jpg";

  const [open, setOpen] = useState(false);
  const ddRef = useRef(null);

  useEffect(() => {
    const onClickOutside = (e) => { if (ddRef.current && !ddRef.current.contains(e.target)) setOpen(false); };
    const onEsc = (e) => { if (e.key === "Escape") setOpen(false); };
    window.addEventListener("mousedown", onClickOutside);
    window.addEventListener("keydown", onEsc);
    return () => {
      window.removeEventListener("mousedown", onClickOutside);
      window.removeEventListener("keydown", onEsc);
    };
  }, []);

  const handleLogoutClick = async () => {
    try {
      // ÇEREZ TEMİZLENSİN DİYE withCredentials:true (instance'da açık)
      await api.post("/auth/logout");
      // FE tarafı temizliği
      localStorage.clear();
      setProfile(null);
      toast.success("Başarıyla çıkış yaptınız!");
      // Login sayfasına "sessiz refresh yapma" işaretiyle gönder
      navigate("/?fresh=1", { replace: true });
    } catch {
      toast.error("Çıkış yapılamadı ❌");
    }
  };

  const isDark = theme === "dark";
  const toggleTheme = () => setTheme(isDark ? "light" : "dark");

  return (
    <nav className="navbar">
      <button className="hamburger-btn" onClick={onHamburgerClick} aria-label="Menü">
        ☰
      </button>
      <Link to="/" className="navbar-logo">
        <img src="/logo.png" alt="TuraÇevre Logo" />
        <span className="navbar-title">Tura Çevre</span>
      </Link>

      <div className="navbar-right">
        {/* PROFİL DROPDOWN */}
        <div className="profile-dropdown" ref={ddRef}>
          <button className="profile-trigger" onClick={() => setOpen((v) => !v)}>
            <span className="avatar">
              <img
                src={imgSrc}
                alt="Profil"
                onError={(e) => {
                  if (e.currentTarget.dataset.errorFired) return;
                  e.currentTarget.dataset.errorFired = "true";
                  if (!e.currentTarget.src.includes("/noavatar.jpg")) {
                    e.currentTarget.src = "/noavatar.jpg";
                  }
                }}
              />
            </span>
            <span className="who">
              <span className="name">{displayName}</span>
              <span className="role">{displayRole}</span>
            </span>
            <svg className={`chev ${open ? "up" : ""}`} viewBox="0 0 24 24" width="18" height="18" aria-hidden>
              <path d="M7 10l5 5 5-5H7z" fill="currentColor" />
            </svg>
          </button>

          <div className={`menu ${open ? "open" : ""}`} role="menu">
            <div className="menu-head">
              <span className="mh-name">{displayName}</span>
              <span className="mh-role">{displayRole}</span>
            </div>

            <button className="item" onClick={() => { setOpen(false); navigate("/profile"); }}>Profilim</button>
            <button className="item" onClick={() => { setOpen(false); navigate("/settings"); }}>Ayarlar</button>

            <div className="sep" />

            {/* TEMA SATIRI */}
            <div className="row">
              <span className="row-label">Karanlık Mod</span>
              <button
                className={`dm-toggle sm ${isDark ? "on" : ""}`}
                onClick={(e) => { e.stopPropagation(); toggleTheme(); }}
                aria-label="Tema değiştir"
                title={isDark ? "Aydınlık moda geç" : "Karanlık moda geç"}
              >
                <span className="track">
                  <span className="icon sun" aria-hidden>
                    <svg viewBox="0 0 24 24" width="14" height="14"><path fill="currentColor" d="M6.76 4.84l-1.8-1.79L3.17 4.84l1.79 1.79 1.8-1.79zm10.48 0l1.79-1.79 1.79 1.79-1.79 1.79-1.79-1.79zM12 2v3M12 19v3M4.84 17.24l-1.79 1.79 1.79 1.79 1.79-1.79-1.79-1.79zM19.16 17.24l1.79 1.79-1.79 1.79-1.79-1.79 1.79-1.79zM2 12h3M19 12h3M12 6a6 6 0 100 12 6 6 0 000-12z" /></svg>
                  </span>
                  <span className="icon moon" aria-hidden>
                    <svg viewBox="0 0 24 24" width="14" height="14"><path fill="currentColor" d="M21 12.79A9 9 0 1111.21 3 7 7 0 1021 12.79z" /></svg>
                  </span>
                </span>
                <span className="thumb" />
              </button>
            </div>

            <div className="sep" />

            <button className="item danger" onClick={handleLogoutClick}>Çıkış</button>
          </div>
        </div>

        {/* 🔔 Bildirim Çanı */}
        <NotificationBell />
      </div>
    </nav>
  );
}
